module.exports = __webpack_public_path__ + "static/media/witch.4edc052f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/witch.jpg
// module id = 236
// module chunks = 0